/**
 * Dynamically load Tencent TXLivePusher script for WebRTC push (Web 推流).
 * Required for user-web to push local camera/mic to the call stream.
 * @see https://www.tencentcloud.com/zh/document/product/1071/41881
 */

const TXLivePusherScriptUrl =
  "https://video.sdk.qcloudecdn.com/web/TXLivePusher-2.1.0.min.js";
const SCRIPT_ID = "tx-live-pusher-script";

/**
 * Load TXLivePusher SDK and resolve when window.TXLivePusher is available.
 * Injects the script into document.body (required by Tencent doc).
 * @returns {Promise<boolean>} true when TXLivePusher is available
 */
export function loadTXLivePusher() {
  if (typeof window === "undefined") {
    return Promise.resolve(false);
  }
  if (window.TXLivePusher) {
    return Promise.resolve(true);
  }
  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    return new Promise((resolve) => {
      if (window.TXLivePusher) {
        resolve(true);
        return;
      }
      existing.addEventListener("load", () => resolve(!!window.TXLivePusher));
      existing.addEventListener("error", () => resolve(false));
    });
  }
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = TXLivePusherScriptUrl;
  script.charset = "utf-8";
  script.async = true;
  return new Promise((resolve) => {
    script.onload = () => resolve(!!window.TXLivePusher);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
